import { Component, Watch, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class TextInput extends Vue {
    @Prop()
    value: any

    public get formattedValue(){
        return this.value;
    }
}
